module.exports = __webpack_public_path__ + "static/vector-shape7-cc15b33d6197b676b381dd4499730738.png";